@switch (mode) {
  @case ('resetPassword') {
    <div class="mx-auto max-w-md">
      <app-card>
        <form
          [formGroup]="resetPasswordForm"
          (ngSubmit)="resetPassword()"
          class="space-y-5"
        >
          @if (showAlert) {
            <app-alert [severity]="severity" [message]="message" />
          }

          <div>
            <h1 class="text-xl font-bold text-fg">Wachtwoord resetten</h1>
            <p class="mt-1 text-sm text-fg-muted">Kies een nieuw wachtwoord</p>
          </div>

          <app-field
            label="Nieuw wachtwoord"
            for="password"
            [control]="password"
          >
            <input
              appInput
              [control]="password"
              formControlName="password"
              id="password"
              type="password"
              autocomplete="new-password"
            />
          </app-field>

          <app-field
            label="Wachtwoord bevestigen"
            for="confirm_password"
            [control]="confirm_password"
          >
            <input
              appInput
              [control]="confirm_password"
              formControlName="confirm_password"
              id="confirm_password"
              type="password"
              autocomplete="new-password"
            />
          </app-field>

          <button
            appButton
            type="submit"
            class="w-full"
            [disabled]="
              resetPasswordForm.invalid ||
              resetPasswordForm.pending ||
              inSubmission
            "
          >
            Reset
          </button>
        </form>
      </app-card>
    </div>
  }
  @case ('verifyAndChangeEmail') {
    <div class="mx-auto max-w-md">
      <app-card>
        <div class="text-center">
          <h1 class="text-xl font-bold text-fg">E-mailadres bevestigen</h1>
          <p class="mt-1 text-sm text-fg-muted">
            Even geduld, we passen je e-mailadres aan.
          </p>
          @if (showAlert) {
            <div class="mt-4">
              <app-alert [severity]="severity" [message]="message" />
            </div>
          }
        </div>
      </app-card>
    </div>
  }
}
